<template>
    <div class="checkpoint" :class="{'with-times':manageTravelTime}">
        <div class="col-left text-xs flex">
            <span class="text">(
                <span class="more-less-symbol">
                    <span class="more">+</span><!--
                    --><span class="sep">/</span><!--
                    --><span class="less">-</span>
                </span>
            </span><!--
            --><input class="form-input delta text-md"
                      type="text"
                      v-model.number="checkpoint.delta"
                      @blur="handleModifCheckpointDelta"/><!--
            --><span class="text">min)</span><!--
            --><input v-show="theoricStartAt == null"
                      :readonly="fieldIsReadonly(number)"
                      class="form-input text-md travel-time"
                      :class="{invalid:checkpoint.errorTime}"
                      v-model.number="checkpoint.travelTimeSinceLast"
                      @blur="handleModifCheckpointSinceLast"
                      type="text"/><!--
            --><input v-show="theoricStartAt != null"
                      :readonly="fieldIsReadonly(number)"
                      type="text"
                      v-inputmask="'99:99'"
                      v-model.lazy="checkpoint.travelHourSinceStart"
                      @blur=""
                      class="form-input clock-picker-handler"
                      :class="{invalid:checkpoint.errorTime}"
                      :disabled="fieldIsReadonly(number)"
                      />
            <!--<ClockPicker v-show="theoricStartAt != null"
                            v-model="checkpoint.travelHourSinceStart"
                            :inputclass="'form-input travel-time'"
                            :nullable="true"
                            :mini="true">
            </ClockPicker>--><!--
            --><span class="time-with-delta text-gray-500 start"
                     v-show="theoricStartAt != null">
                {{ getMinTimeFromDelta(checkpoint) }}
            </span><!--
            --><span class="time-with-delta text-gray-500 end"
                     v-show="theoricStartAt != null">
                {{ getMaxTimeFromDelta(checkpoint) }}
            </span>
        </div>
        <div class="col-center">
            <div class="number">{{ number + 1 }}</div>
            <div class="description">
                <i class="icon fa-fw" :class="iconAP(checkpoint.type)"></i><span
                    class="name">{{ checkpoint.name }}</span><span class="path clearfix"
                                                                   v-html="constructPath(checkpoint.plans)"></span>
            </div>
        </div>
        <div class="col-right flex">
            <i class="fa fa-fw fa-arrows-v"></i>
            <i class="fa fa-fw fa-pencil" @click.stop="handleEditCheckpoint(number)"></i>
            <i class="fa fa-fw fa-trash" @click.stop="handleDeleteCheckpoint(number)"></i>
        </div>
    </div>
</template>

<script>

    import moment from 'moment';

    import Icons from '@/services/iconMapping.js';
    import ClockPicker from '@/components/ui/datetime/TimePicker';

    export default {
        components: {
            ClockPicker
        },
        methods: {
            iconAP: function (type) {
                return Icons.actionpoints[type]
            },
            constructPath: function (plans) {
                if (plans != null) {
                    var output = '';
                    for (var i = 0; i < plans.length; i++) {
                        var plan = plans[i];

                        output += '<span><i class="icon-plan ' + Icons.plans[plan.type] + '"></i>' + plan.name + '</span>';

                        if (i < plans.length - 1) {
                            output += '<i class="fa fa-chevron-right"></i>';
                        }
                    }

                    return output;
                }
                return '';

            },
            handleEditCheckpoint: function (key) {

                this.$emit('editCheckpoint',key);
            },
            handleDeleteCheckpoint: function (key) {
                //this.patrol.checkpoints.splice(key, 1);
                this.$emit('deleteCheckpoint',key);
            },
            getMinTimeFromDelta(checkpoint) {
                if (checkpoint.travelHourSinceStart && checkpoint.delta != 0) {
                    return moment(checkpoint.travelHourSinceStart, 'HH:mm').subtract(checkpoint.delta, 'minutes').format('HH:mm');
                }
                return '';
            },
            getMaxTimeFromDelta(checkpoint) {
                if (checkpoint.travelHourSinceStart && checkpoint.delta != 0) {
                    return moment(checkpoint.travelHourSinceStart, 'HH:mm').add(checkpoint.delta, 'minutes').format('HH:mm');
                }
                return '';
            },
            fieldIsReadonly: function(index){
                if(index == 0){
                    return true;
                }
                return false;
            },
            handleModifCheckpointDelta: function(){
                this.$emit('modifCheckpointDelta',this.number,this.checkpoint.delta);
            },
            handleModifCheckpointSinceLast: function(){
                this.checkpoint.travelTimeSinceLast = parseInt(this.checkpoint.travelTimeSinceLast);
                this.$emit('modifCheckpointSinceLast',this.number,parseInt(this.checkpoint.travelTimeSinceLast));
            },
        },
        name: '',
        props: {
            manageTravelTime: {
                type: [Boolean,Number],
                default: false
            },
            checkpoint: {
                type: Object,
                required: true
            },
            theoricStartAt: {
                type: String,
                default: null
            },
            number: {
                type: Number,
                required: true
            }
        },
        watch: {
            "checkpoint.travelHourSinceStart": function(newVal,oldVal){
                if(this.checkpoint){
                    this.$emit('modifCheckpointHourSinceStart',this.number,this.checkpoint.travelHourSinceStart);
                }

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
